import { ROLE_MATCH_MODE } from "constants/constants";
import { FAF_LATE_POPUP_ACCESS, FAF_TOOL_ACCESS } from "access-roles/roles";
import _ from "lodash";

export const checkIntersection = ({ userRoles, actionRoles }) =>
  !_.chain(userRoles)
    .map(_.toUpper)
    .intersectionWith(actionRoles, _.isEqual)
    .isEmpty()
    .value();

export const canUserPerformAction = ({
  userRoles,
  requiredRoles,
  mode = ROLE_MATCH_MODE.AND,
}) => {
  const requiredRolesArray = Array.isArray(requiredRoles)
    ? requiredRoles
    : [requiredRoles];

  if (mode === ROLE_MATCH_MODE.OR) {
    return requiredRolesArray.some((role) => userRoles.includes(role));
  }

  return requiredRolesArray.every((role) => userRoles.includes(role));
};

// A section opens when the user holds its requiredRoles (combined with
// rolesMatchMode, AND by default), at least one of its anyOfRoles and none of
// its excludedRoles. Holding one of its overrideRoles opens it anyway. The
// last three are optional.
export const canAccessSection = (
  {
    requiredRoles,
    rolesMatchMode,
    anyOfRoles,
    excludedRoles = [],
    overrideRoles = [],
  },
  userRoles = []
) =>
  overrideRoles.some((role) => userRoles.includes(role)) ||
  (canUserPerformAction({ userRoles, requiredRoles, mode: rolesMatchMode }) &&
    (!anyOfRoles?.length ||
      canUserPerformAction({
        userRoles,
        requiredRoles: anyOfRoles,
        mode: ROLE_MATCH_MODE.OR,
      })) &&
    !excludedRoles.some((role) => userRoles.includes(role)));

// The F&F tab of the tools manager.
export const canAccessFafTool = (userRoles) =>
  canAccessSection(FAF_TOOL_ACCESS, userRoles);

// The late declaration popup is for declarants only.
export const canSeeFafLatePopup = (userRoles) =>
  canAccessSection(FAF_LATE_POPUP_ACCESS, userRoles);

// Sections of a navigation bar the user may see, in declaration order.
export const getAccessibleSections = ({ sections, userRoles }) =>
  sections?.filter((section) => canAccessSection(section, userRoles));
